import React, { useEffect } from "react";

const VentasNotasCreditoPage = () => {
  useEffect(() => {
    document.title = "Ventas - Notas de crédito | Saas";
  }, []);

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title mb-3">Notas de crédito</h4>
            <p className="text-muted mb-0">
              Aquí vas a poder emitir y administrar notas de crédito vinculadas a facturas de ventas, para ajustar
              devoluciones, diferencias o descuentos posteriores.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VentasNotasCreditoPage;
